import {UnitBulkOperationDto} from "src/SharedCustomHooks/UsePropertySuites/types";
import {ISuite} from "src/components/SharedTypes";
import React, {useMemo} from "react";
import UnitSelectionCard from "src/components/UnitSelectionCard/UnitSelectionCard";
import {
  UnitActions
} from 'src/components/BulkOperations/Walkthroughs/BulkActivationWalkthroughsDialogue/BulkActivateWalkthroughsDialogue';
import "./UnitsSelectionGrid.scss";

interface UnitsSelectionGridProps {
  suites: UnitBulkOperationDto[];
  selectedUnitIds: Set<string>;
  isLoadingUnit: string | null;
  unitActions: UnitActions;
  detailedSuites: ISuite[];
  isFetchingWalkthroughs: boolean;
  sendSchedulingEmail: boolean
}

const UnitsSelectionGrid = ({
  suites,
  selectedUnitIds,
  isLoadingUnit,
  unitActions,
  detailedSuites,
  isFetchingWalkthroughs,
  sendSchedulingEmail
}: UnitsSelectionGridProps) => {
  const { toggle, getWalkthroughs }: UnitActions = unitActions;

  const detailedSuiteLookup = useMemo(() => {
    const map: Record<string, ISuite> = {};

    detailedSuites.forEach(suite => {
      if (suite.id) {
        map[suite.id] = suite;
      }
    });

    return map;
  }, [detailedSuites]);

  return (
    <div className="units-grid">
      {suites.map((suite: UnitBulkOperationDto) => {
        const detailedSuite: ISuite = detailedSuiteLookup[suite.id];
        const pendingCount: number = detailedSuite?.walkthourhgsCount ?? 0;

        return (
          <UnitSelectionCard
            key={suite.id}
            suite={suite}
            isSelected={selectedUnitIds.has(suite.id)}
            isLoading={isLoadingUnit === suite.id}
            walkthroughs={getWalkthroughs(suite.id)}
            onToggle={toggle}
            pendingWalkthroughCount={pendingCount}
            isFetchingWalkthroughs={isFetchingWalkthroughs}
            sendSchedulingEmail={sendSchedulingEmail}
          />
        );
      })}
    </div>
  );
};

export default UnitsSelectionGrid